export default __webpack_public_path__ + "static/media/nesto-online-app3.302b7365.png";